export default __webpack_public_path__ + "static/media/pi.f6925af8.svg";